module.exports = __webpack_public_path__ + "img/UTGREE-4.0fdda9bb.jpg";